import { render, staticRenderFns } from "./TeacherPosition.vue?vue&type=template&id=e07ebf9e"
import script from "./TeacherPosition.vue?vue&type=script&lang=js"
export * from "./TeacherPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e07ebf9e')) {
      api.createRecord('e07ebf9e', component.options)
    } else {
      api.reload('e07ebf9e', component.options)
    }
    module.hot.accept("./TeacherPosition.vue?vue&type=template&id=e07ebf9e", function () {
      api.rerender('e07ebf9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/TeacherPosition.vue"
export default component.exports